/**
 * axios全局配置
 * TODO: 拦截器全局配置，根据实际情况修改
 */
import axios from 'axios';

// 超时设置
const service = axios.create({
  // 请求超时时间
  timeout: 30000,
});

// http request 拦截器
// 每次请求都为http头增加token字段，其内容为token
service.interceptors.request.use(
  (config) => new Promise((resolve) => {
    resolve(config);
  }),
  (err) => Promise.reject(err),
);

// http response 拦截器
service.interceptors.response.use(
  (response) => Promise.resolve(response),
  (error) => {
    console.log(error.response);
    return Promise.reject(error.response);
  },
);

export default service;
